<template>
  <div class="accBind">
    <router-view :userInfo = userInfo></router-view>
  </div>
</template>

<script>
export default {
  name: "accBind",
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
  },
  mounted() {
    this.$parent.resetHeightFn()
  },
  created() {},
  props:{
    userInfo:{
      type: Object,
      default: {}
    }
  },
  beforeCreate() {}
};
</script>
<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/components/index/accBind/index.vue